var vertical_embed_viewer_default = {
  "card": "EQOZ0",
  "slimLayout": "TpxRr",
  "cardLayout": "scTH7",
  "imageContainer": "Mh2uZ",
  "image": "EoQ61",
  "content": "Py3yN"
};
export {
  vertical_embed_viewer_default as default
};
//# sourceMappingURL=vertical-embed-viewer-scss.js.map
